'use strict';
export let root = ()=>import('./root.vue')
